export enum AggregateDateFacetTypesEnum {
    SUM_AD_VALUE_USD = 'SUM_AD_VALUE_USD',
    AVG_AD_VALUE_USD = 'AVG_AD_VALUE_USD',
    SUM_AUDIENCE_REACH = 'SUM_AUDIENCE_REACH',
    AVG_AUDIENCE_REACH = 'AVG_AUDIENCE_REACH',
    AVG_DOMAIN_AUTHORITY = 'AVG_DOMAIN_AUTHORITY',
    SUM_DOMAIN_AUTHORITY = 'SUM_DOMAIN_AUTHORITY'
}
